<template>
	<div class="i-container">
		<main-header class="i-h"></main-header>
		<div class="t-header">
			<img src="../assets/home/index-banner.png" alt="" />
			<div class="th-con">
				<div class="flex-center">
					<div class="label">赛程安排</div>
					<div class="value-group col-center">
						<div class="line">
						</div>
						<div class="arrow"></div>
						<div class="value-item flex-center" v-for="(item,index) in bannerProList" :key="index">
							<img :src="item.icon" alt="" />
							<div class="con">
								{{item.title}}
							</div>
							<div class="date row-center" v-if="item.date">
								<img src="../assets/home/line.png" alt="" />
								<div class="time">
									<div class="sport"></div>
									{{item.date}}
								</div>
							</div>
							<div class="after">
								<img :src="item.after" alt="" />
								<div class="after-con">{{item.arterText}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex-sb">
			<div class="content">
				<div class="content-nav flex-sb">
					<div class="col-center">
						<div class="title col-center">
							{{authority === 'expert' ? '参赛作品评审' : '参赛作品管理'}}
						</div>
					</div>
					<div class="right col-center">
						<!-- <div class="search col-center" :style="authority === 'expert' ? 'padding-right: 0;' : ''">
							<div class="el-input">
								<el-input placeholder="输入关键字搜索" prefix-icon="el-icon-search" v-model="queryForm.key_words">
								</el-input>
							</div>
							<div class="search-btn">
								<el-button type="primary" @click="search">搜索</el-button>
							</div>
						</div> -->
						<div class="sub-btn" v-if="authority != 'expert'"> <el-button type="primary"
								@click="$router.push('/history')">已提交作品记录</el-button></div>
					</div>
				</div>
				<div class="col-center wrap" style="margin-top: 18px;" v-if="schoolAdminInfo">
					<div class="content-admin-cell">学校：<span>{{schoolAdminInfo.school_name}}</span></div>
					<div class="content-admin-cell">管理员：<span>{{schoolAdminInfo.name}}</span></div>
					<div class="content-admin-cell">联系电话：<span>{{schoolAdminInfo.mobile}}</span></div>
				</div>
				<div class="group" v-loading="loading">
					<div v-if="list && list.length">
						<div class="item" @mouseover="mouseover(index)" @click="toDetail(item)"
							v-for="(item,index) in list" :key="index">
							<review-card :actived="index === hoverIndex" :item="item"></review-card>
						</div>
					</div>
					<div v-else style="text-align: center;padding: 3.125rem;">
						暂无数据
					</div>
				</div>
			</div>
			<div class="content">
				<div class="content-nav flex-sb col-center">
					<div class="col-center">
						<div class="title col-center">
							校赛动态
						</div>
					</div>
					<div class="more">更多+</div>
				</div>
				<div class="notice-group" v-if="schoolNotice && schoolNotice.length">
					<div class="notice-item flex-sb col-center" v-for="(item,index) in schoolNotice" :key="index"
						@click="toNoticeDetail(item)">
						<div class="notice-title">{{item.title}}</div>
						<div class="notice-date">{{item.created_at}}</div>
					</div>
				</div>
				<div class="flex-center" style="padding-top: 20px;" v-else>暂无校赛动态</div>
			</div>
			<div class="content">
				<div class="content-nav flex-sb col-center">
					<div class="col-center">
						<div class="title col-center">
							省赛动态
						</div>
					</div>
					<div class="more">更多+</div>
				</div>
				<div class="notice-group" v-if="provinceNotice && provinceNotice.length">
					<div class="notice-item flex-sb col-center" v-for="(item,index) in provinceNotice" :key="index"
						@click="toNoticeDetail(item)">
						<div class="notice-title">{{item.title}}</div>
						<div class="notice-date">{{item.created_at}}</div>
					</div>
				</div>
				<div class="flex-center" style="padding-top: 20px;" v-else>暂无省赛动态</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mainHeader from '@/components/main-header/main-header'
	import reviewCard from './components/review-card'
	import processM from './components/process-m'
	import {
		getListJ,
		getListZ,
		getSchoolAdminInfo,
		getSchoolNoticeList,
		getProvinceNoticeList
	} from '@/common/api/home.js'
	import {
		getProcessList
	} from '@/common/api/process.js'
	export default {
		name: '',
		props: {

		},
		components: {
			mainHeader,
			reviewCard,
			processM
		},
		data() {
			return {
				searchkey: '',
				hoverIndex: '',
				hoverIndex2: '',
				queryForm: {
					page: 1,
					per_page: 6,
					key_words: ''
				},
				queryForm2: {
					page: 1,
					per_page: 3,
					key_words: ''
				},
				loading: false,
				total: 0,
				total2: 0,
				list: [],
				list2: [],
				bannerProList: [{
					icon: require('../assets/home/box01.png'),
					title: '报名启动',
					date: '10月'
				}, {
					icon: require('../assets/home/box02.png'),
					title: '赛事宣讲',
					date: '10月'
				}, {
					icon: require('../assets/home/box03.png'),
					title: '参赛报名',
					date: '10月15日前'
				}, {
					icon: require('../assets/home/box04.png'),
					title: '校赛',
					date: '11月4日前'
				}, {
					icon: require('../assets/home/box05.png'),
					title: '省赛',
					date: '11月25日前'
				}, {
					icon: require('../assets/home/box06.png'),
					title: '国赛',
					date: '12月',
					after: require('../assets/home/tips.png'),
					arterText: '11月30日前国赛系统提交申报材料'
				}],
				schoolAdminInfo: {},
				schoolNotice: [],
				provinceNotice: []
			}
		},
		created() {

		},
		mounted() {
			this.getList()
			this.getSchoolAdminInfo()
			this.getNoticeList()
			this.getProvinceNoticeList()
		},
		methods: {
			async getSchoolAdminInfo() {
				const {
					data
				} = await getSchoolAdminInfo()
				console.log(data)
				this.schoolAdminInfo = data
			},
			async getList() {
				let queryFun = this.authority === 'expert' ? getListZ : getListJ;
				this.loading = true
				try {
					const {
						data
					} = await queryFun(this.queryForm)
					this.list = data.data
					this.total = Number(data.meta.pagination.total)
					this.loading = false
				} catch (e) {
					this.loading = false
					console.log(e)
				}
			},
			async getNoticeList() {
				const {
					data
				} = await getSchoolNoticeList({
					per_page: 15
				})
				this.schoolNotice = data.data
			},
			async getProvinceNoticeList() {
				const {
					data
				} = await getProvinceNoticeList({
					per_page: 15
				})
				this.provinceNotice = data.data
			},
			async getProcessList() {
				this.loading = true
				try {
					const {
						data
					} = await getProcessList(this.queryForm2)
					this.list2 = data.data
					this.total2 = Number(data.meta.pagination.total)
					this.loading = false
				} catch (e) {
					console.log(e)
					this.loading = false
				}
			},
			mouseover(index) {
				this.hoverIndex = index
			},
			toDetail(item) {

				this.$router.push('/detail?id=' + (item.id || item.audit_project_id))
			},
			handleSizeChange(e) {
				this.queryForm.page = 1
				this.queryForm.per_page = e
				this.getList()
			},
			handleCurrentChange(e) {
				console.log(e)
				this.queryForm.page = e
				this.getList()
			},
			search() {
				this.queryForm.page = 1
				this.getList()
			},
			// 项目过程管理
			toDetail2(item) {
				this.$router.push('/process-advancement?audit_project_id=' + item.audit_project_id + "&id=" + item.id)
			},
			handleSizeChange2(e) {
				this.queryForm2.page = 1
				this.queryForm2.per_page = e
				this.getProcessList()
			},
			handleCurrentChange2(e) {
				console.log(e)
				this.queryForm2.page = e
				this.getProcessList()
			},
			search2() {
				this.queryForm2.page = 1
				this.getProcessList()
			},
			mouseover2(index) {
				this.hoverIndex2 = index
			},
			toNoticeDetail(item) {
				if (item.url) {
					window.open(item.url)
				} else {
					this.$router.push("/noticeDetail?id=" + item.id)
				}
			}
		}

	}
</script>

<style lang="scss" scoped>
	.i-container {
		width: 100vw;
		height: 100vh;
		background-color: #F7F7F7;
		display: flex;
		flex-direction: column;

		::v-deep .breadcrumbs-container {
			background-color: #1A81DF;
			color: white;

			.icon {
				color: white;
			}

			.group {
				.home:hover>.hover {
					text-decoration: underline;
					color: #fff;
				}

				.item.current {
					color: #fff;
				}
			}
		}

		.t-header {
			position: relative;

			img {
				width: 100%;
			}

			.th-con {
				position: absolute;
				left: 0;
				right: 0;
				top: 8.3vw;
				bottom: 0;
				z-index: 3;

				.label {
					font-size: 24px;
					color: #FFFFFF;
					margin-right: 60px;
				}

				.value-group {
					position: relative;
					padding-left: 20px;

					.value-item {
						margin-right: 20px;
						position: relative;

						.con {
							position: absolute;
							z-index: 2;
							color: white;
							font-size: 20px;
							margin-top: 0px;
						}

						.after {
							position: absolute;
							bottom: 100%;
							left: 0;
							width: 160px;
							height: 60px;

							.after-con {
								position: absolute;
								z-index: 2;
								left: 18px;
								right: 18px;
								top: 5px;
								bottom: 18px;
								font-size: 14px;
								color: white;
							}
						}

						.date {
							position: absolute;
							top: 100%;
							z-index: 2;
							flex-wrap: wrap;
							height: 75px;

							img {
								width: 1px;
							}



							.time {
								margin-top: 10px;
								width: 100%;
								color: white;
								position: relative;
								padding-top: 2px;
								font-size: 20px;

								.sport {
									position: absolute;
									bottom: 100%;
									left: 50%;
									margin-left: -2px;
									width: 6px;
									height: 6px;
									background: #00D8FF;
									border-radius: 50%;
									border: 1px solid #B7DCFF;
								}
							}
						}
					}

					.line {
						width: 100%;
						position: absolute;
						left: 0;
						top: 50%;
						border-top: 1px solid white;
						margin-top: 0px;
						// z-index: 1;
					}

					.arrow {
						position: absolute;
						top: 50%;
						margin-top: -4px;
						left: 100%;
						border-left: 5px solid white;
						border-top: 5px solid transparent;
						border-right: 5px solid transparent;
						border-bottom: 5px solid transparent;
						z-index: 2;
					}
				}
			}
		}

		.i-h {
			flex-shrink: 0;
		}

		// .content.z {
		// 	height: 0;
		// 	flex-grow: 1;

		// 	.group {
		// 		height: 0;
		// 		flex-grow: 1;
		// 	}
		// }

		.content {
			margin: 0.625rem 0;
			border-radius: 0.375rem;
			background-color: white;
			display: flex;
			flex-direction: column;
			// height: 100%;
			min-height: 374px;
			width: calc((100% - 20px) / 3);

			.content-admin-cell {
				color: #666;
				margin-left: 20px;

				span {
					color: #000;
				}
			}

			.content-nav {
				padding: 16px;
				border-bottom: 1px solid #E7EBF0;
				flex-shrink: 0;

				.title {
					font-size: 24px;
					font-weight: bold;
					position: relative;
					padding-left: 1.5rem;
				}

				.title::after {
					content: "";
					display: block;
					width: 0.25rem;
					height: 1rem;
					position: absolute;
					background-color: #4389E0;
					left: 0.625rem;
					top: 50%;
					margin-top: -8px;
				}

				.right {
					.search {
						padding: 0 4.375rem;

						.el-input {
							width: 20rem;
						}
					}

					.search-btn {
						padding: 0 0.625rem;
					}
				}

				.more {
					font-size: 16px;
					color: #0085FF;
				}
			}

			.group {
				padding: 0.625rem;
				align-content: flex-start;
				background-color: #F7FAFE;

				.item {
					width: 100%;
					margin: 0.625rem 0;
					cursor: pointer;
				}
			}

			.pages {
				padding: 2.5rem;
				display: flex;
				justify-content: flex-end;
			}

			.pages-small {
				display: none;
			}

			.notice-group {
				padding: 10px;

				.notice-item {
					padding: 15px 10px;

					.notice-title {
						font-size: 16px;
						color: #000000;
						flex-grow: 1;
						width: 0;
						padding-right: 20px;
						cursor: pointer;
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden;
					}

					.notice-title:hover {
						text-decoration: underline;
					}

					.notice-date {
						font-size: 16px;
						color: #7F7F7F;
					}
				}
			}
		}
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.i-container {
			.content {
				.content-nav {
					display: block;

					.title {
						font-size: 1.125rem;
					}

					.right {
						.search {
							padding: 1.25rem 0 0;
							width: 100%;

							.el-input {
								width: auto;
								flex-grow: 1;

								::v-deep {
									.el-input {
										width: 100%;
									}
								}
							}
						}

						.sub-btn {
							padding: 1.25rem 0 0;
						}
					}
				}

				.group {
					flex-wrap: wrap;

					.item {
						width: 100%;
						margin: 0.625rem 0 !important;
					}
				}

				.pages {
					display: none;
				}

				.pages-small {
					display: block;
					padding: 1.25rem;

					::v-deep {
						.el-pagination {
							display: flex;
							justify-content: center;
							transform: scale(1.2);
						}
					}
				}
			}

		}

	}
</style>